import React from 'react';
import { useParams } from 'react-router-dom';


import Layout from '../../components/web/Layout';
import MembershipApplication from '../../components/web/form/MembershipApplication';

function Form() {
  const { type } = useParams();

  let FormComponent;

  switch (type) {
    case 'Membership_Form':
      FormComponent =
        <MembershipApplication />;
      break;
    default:
      FormComponent = <div>Invalid form type: {type}</div>;
  }

  return (
    <Layout>
      {FormComponent}
    </Layout>
  );
}

export default Form;
